import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./Home";
import SBSBadge from "./components/SBSBadge";
import DominicanaPage from './DominicanaPage';
import AboutPage from './AboutPage';
import OnboardingPage from './OnboardingPage';

function App() {
  return (
    <Router>
      <div className="app-container">
        <SBSBadge />
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/client-inquiry" element={<Navigate to="/onboarding" replace />} />
	      <Route path="/dominicana" element={<DominicanaPage />} />
		  <Route path="/about" element={<AboutPage />} />
		  <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="*" element={<Home />} /> {/* Fallback to Home if path is invalid */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
